import _ from 'lodash';
import { evaluateConditions } from '../../../condition-engine/evaluateConditions';
import { evaluateQuery } from '../../../condition-engine/queries';
import { generateValidationDataFromValidationType } from '../../../condition-engine/validationData';
import { hasBeenAnswered } from '../../answers/helpers';
import { isMessageQuery } from './validityRule';
export function evaluateRules(rules, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride, fieldTypeValidation) {
    const validRules = [];
    const invalidRules = [];
    let validationData = {};
    for (const rule of rules) {
        const { isValid } = evaluateConditions(rule.conditions, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride);
        const evaluatedMessageParams = rule.messageParams &&
            evaluateMessageParams(rule.messageParams, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride);
        if (isValid) {
            validRules.push({ isValid, message: rule.message, evaluatedMessageParams });
        }
        else {
            invalidRules.push({ isValid, message: rule.message, evaluatedMessageParams });
        }
    }
    if (fieldTypeValidation) {
        validationData = {
            ...generateValidationDataFromValidationType(fieldTypeValidation, timezone, validationData, currentDateOverride),
        };
    }
    return { validRules, invalidRules, validationData };
}
function evaluateMessageParams(messageParams, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride) {
    return _.mapValues(messageParams, (value) => {
        if (isMessageQuery(value)) {
            return evaluateQuery(value.fromQuery, answersResolver, repeatedInstanceIdentifiers, timezone, {}, currentDateOverride);
        }
        return value;
    });
}
function createValidityVisitor({ processFieldEvaluation }, answersResolver, timezone, currentDateOverride) {
    const visitField = (navigation, { node, answersResolver, repeatedInstanceIdentifiers }) => {
        const nodeWithEvaluatedVisibility = node;
        if (!nodeWithEvaluatedVisibility.visible) {
            // Invisible nodes cannot be invalid
            return;
        }
        const { invalidRules, validationData } = evaluateRules(node.validIf ?? [], answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride, node?.validation?.type);
        const fieldAnswer = answersResolver.usingNodeId().getAnswer(node.blueprintId, repeatedInstanceIdentifiers);
        processFieldEvaluation({
            node: node,
            hasBeenAnswered: hasBeenAnswered(fieldAnswer),
            brokenRules: invalidRules,
            validationData,
        });
    };
    return {
        visitDefault: (navigation) => navigation.visitChildren(),
        visitField,
        complete: () => { },
    };
}
export { createValidityVisitor };
